import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { PayoutsRes } from 'features/payouts/types/payouts.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchPayouts = () => {
	const { auth } = useContext(AuthContext)
	const axiosPrivate = useAxiosPrivate()
	const query = getCurrentQuery()

	const {
		data: payouts,
		isPending: isPayoutsLoading,
		isSuccess: isPayoutsSuccess
	} = useQuery<PayoutsRes>({
		queryKey: queryKeys.payouts.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.payouts(query)),
		enabled: !!auth.accessToken
	})

	return {
		payouts,
		isPayoutsLoading,
		isPayoutsSuccess
	}
}
